'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _productTypeSelector = require('./../product-type-selector');

var _productTypeSelector2 = _interopRequireDefault(_productTypeSelector);

var _largeButton = require('../large-button');

var _largeButton2 = _interopRequireDefault(_largeButton);

var _reactI18next = require('react-i18next');

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_reactI18next.translate.setI18n(_i18n2.default);

var Home = function (_React$Component) {
    _inherits(Home, _React$Component);

    function Home(props) {
        _classCallCheck(this, Home);

        return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
    }

    _createClass(Home, [{
        key: 'render',
        value: function render() {
            var t = this.props.t;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'a',
                    { className: 'back-link', href: t('backLink') },
                    t('Back')
                ),
                _react2.default.createElement('h1', { className: 'f-weight-normal',
                    dangerouslySetInnerHTML: { __html: t('Planning tool HAWA-Concepta-component') } }),
                _react2.default.createElement(_productTypeSelector2.default, { history: this.props.history,
                    t: this.props.t }),
                _react2.default.createElement(
                    'p',
                    null,
                    this.props.t('For illustration purposes, here is the result of an')
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_largeButton2.default, {
                        isLink: true,
                        href: '/static/assets/beispiel-konfiguration.pdf',
                        text: this.props.t('example configuration')
                    })
                )
            );
        }
    }]);

    return Home;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)([])(Home);


//////////////////
// WEBPACK FOOTER
// ./client/components/home/index.js
// module id = 476
// module chunks = 0